var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityLikesIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3428 1.72654C9.22206 0.696016 7.75512 0.124071 6.23262 0.124023C5.42677 0.124862 4.62905 0.285056 3.88535 0.595385C3.14166 0.905714 2.46667 1.36005 1.89925 1.93225C-0.520983 4.36277 -0.519955 8.16437 1.9013 10.5846L9.44279 18.1261C9.61765 18.4336 9.95502 18.6321 10.3428 18.6321C10.502 18.6306 10.6587 18.5917 10.8001 18.5187C10.9416 18.4456 11.064 18.3404 11.1574 18.2115L18.7843 10.5846C21.2055 8.16334 21.2055 4.36277 18.7822 1.92814C18.2151 1.35699 17.5406 0.903574 16.7977 0.59396C16.0547 0.284346 15.2579 0.12464 14.453 0.124023C12.9305 0.124272 11.4636 0.69619 10.3428 1.72654ZM17.3278 3.38254C18.9355 4.99842 18.9365 7.52254 17.3299 9.1302L10.3428 16.1173L3.3557 9.1302C1.74907 7.52254 1.7501 4.99842 3.35365 3.38665C4.13536 2.60905 5.15776 2.18117 6.23262 2.18117C7.30747 2.18117 8.32576 2.60905 9.1013 3.38459L9.61559 3.89888C9.71103 3.99448 9.82438 4.07033 9.94916 4.12207C10.0739 4.17382 10.2077 4.20046 10.3428 4.20046C10.4779 4.20046 10.6116 4.17382 10.7364 4.12207C10.8612 4.07033 10.9746 3.99448 11.07 3.89888L11.5843 3.38459C13.1395 1.83248 15.7747 1.83659 17.3278 3.38254Z",
    fill: "#E53935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLikesIconColor);
export default __webpack_public_path__ + "static/media/activity-likes-icon-color.889f8237ba74656008e680e35a79897b.svg";
export { ForwardRef as ReactComponent };